import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";
import {CurrencyCode} from "@/models/core/currency";

export const ruMobilePayoutLimits = {
  minAmount: 100,
  maxAmount: 5000,
  maxAmountCurrency: CurrencyCode.RUR,
  minAmountCurrency: CurrencyCode.RUR,
}

export abstract class MobilePaymentModel extends PayoutWebModel {
  systemName = null

  limitMinAmount = null
  limitMinCurrency = null
  limitMaxAmount = null
  limitMaxCurrency = null
  destCurrency = null

  required = [
    'amount', 'description', 'fromAccount',
    'destinationAccount',
    'verificationType'
  ]

  values = {
    ...this.getValues(),
    fromAccount: '', amount: '', label: '',
    verificationType: '', destinationAccount: ''
  }

}

export class MtsPaymentModel extends MobilePaymentModel {
  systemName = PaymentCodeEnum.Mts
  destCurrency = CurrencyCode.RUR

  limitMaxAmount = ruMobilePayoutLimits.maxAmount
  limitMaxCurrency = ruMobilePayoutLimits.maxAmountCurrency
  limitMinAmount = ruMobilePayoutLimits.minAmount
  limitMinCurrency = ruMobilePayoutLimits.minAmountCurrency
}

export class BeelinePaymentModel extends MobilePaymentModel {
  systemName = PaymentCodeEnum.Beeline

  destCurrency = CurrencyCode.RUR

  limitMaxAmount = ruMobilePayoutLimits.maxAmount
  limitMaxCurrency = ruMobilePayoutLimits.maxAmountCurrency
  limitMinAmount = ruMobilePayoutLimits.minAmount
  limitMinCurrency = ruMobilePayoutLimits.minAmountCurrency
}

export class MegafonPaymentModel extends MobilePaymentModel {
  systemName = PaymentCodeEnum.Megafon
  destCurrency = CurrencyCode.RUR

  limitMaxAmount = ruMobilePayoutLimits.maxAmount
  limitMaxCurrency = ruMobilePayoutLimits.maxAmountCurrency
  limitMinAmount = ruMobilePayoutLimits.minAmount
  limitMinCurrency = ruMobilePayoutLimits.minAmountCurrency
}

export class TmobilePaymentModel extends MobilePaymentModel {
  systemName = PaymentCodeEnum.TinkoffMobile
  destCurrency = CurrencyCode.RUR

  limitMaxAmount = ruMobilePayoutLimits.maxAmount
  limitMaxCurrency = ruMobilePayoutLimits.maxAmountCurrency
  limitMinAmount = ruMobilePayoutLimits.minAmount
  limitMinCurrency = ruMobilePayoutLimits.minAmountCurrency
}

export class YotaPaymentModel extends MobilePaymentModel {
  systemName = PaymentCodeEnum.Yota
  destCurrency = CurrencyCode.RUR

  limitMaxAmount = ruMobilePayoutLimits.maxAmount
  limitMaxCurrency = ruMobilePayoutLimits.maxAmountCurrency
  limitMinAmount = ruMobilePayoutLimits.minAmount
  limitMinCurrency = ruMobilePayoutLimits.minAmountCurrency
}

export class Tele2PaymentModel extends MobilePaymentModel {
  systemName = PaymentCodeEnum.Tele2
  destCurrency = CurrencyCode.RUR

  limitMaxAmount = ruMobilePayoutLimits.maxAmount
  limitMaxCurrency = ruMobilePayoutLimits.maxAmountCurrency
  limitMinAmount = ruMobilePayoutLimits.minAmount
  limitMinCurrency = ruMobilePayoutLimits.minAmountCurrency
}

export class UkrainianMobilePaymentModel extends MobilePaymentModel {
  systemName = PaymentCodeEnum.UkrainianMobile
}
